import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCircleExclamation } from '@fortawesome/free-solid-svg-icons/faFileCircleExclamation';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { renderLitresToHL, numberWithSpaces } from 'components/global/utils';
import { valueExist } from '@utils/typescriptGuards';
import BeerIcon from 'components/custom-icon/BeerIcon';
import FreeBeerIcon from 'components/custom-icon/FreeBeerIcon';
import CollectionIcon from 'components/custom-icon/CollectionIcon';
import MerchIcon from 'components/custom-icon/MerchIcon';
import TankIcon from 'components/custom-icon/TankIcon';
import CratesIcon from 'components/custom-icon/CratesIcon';



export type InfobarValues = {
	value1: number | null | undefined;
	showExclamation1: boolean;
	value2: number | null | undefined;
	showExclamation2: boolean;
	value3: number | null | undefined;
	showExclamation3: boolean;
}


interface InfobarProps {
	containsBeer: boolean;
	containsTank: boolean;
	containsFreeBeer: boolean;
	containsCollection: boolean;
	containsEmpties: boolean;
	containsPosm: boolean;
	containsClaim: boolean;
	containsUnknown: boolean;
	
	isCancelled: boolean;
	isReduced: boolean;
	isDelivered: boolean;

	countValues: InfobarValues;
	volumeValues: InfobarValues;
}


export const Infobar = (props: InfobarProps) => {
	const { containsBeer, containsTank, containsFreeBeer, containsCollection, containsEmpties, containsPosm, containsClaim, containsUnknown,
		isCancelled, isReduced, isDelivered, countValues, volumeValues } = props;

	const containsNothing = !containsBeer && !containsTank && !containsFreeBeer && !containsCollection && !containsEmpties && !containsPosm && !containsClaim && !containsUnknown;


	const getStatus = () => {
		if (isCancelled) return ' status-danger';
		if (isReduced) return ' status-warning';
		if (isDelivered) return ' status-success';
		return '';
	};


	return (
		<div className={`component-infobar${getStatus()}`}>
			
			<div className='infobar-icons'>
				{containsBeer && <BeerIcon />}
				{containsTank && <TankIcon />}
				{containsFreeBeer && <FreeBeerIcon />}
				{containsCollection && <CollectionIcon />}
				{containsEmpties && <CratesIcon />}
				{containsPosm && <MerchIcon />}
				{containsClaim && <FontAwesomeIcon icon={faFileCircleExclamation} />}
				{containsUnknown && <FontAwesomeIcon icon={faCircleQuestion} />}

				{containsNothing && <FontAwesomeIcon icon={faCircleQuestion} />}
			</div>

			<p>{`${valueExist(countValues.value1) ? numberWithSpaces(countValues.value1) : '-'

				}${countValues.showExclamation1 ? '!' : ''

				}/${valueExist(countValues.value2) ? numberWithSpaces(countValues.value2) : '-'

				}${countValues.showExclamation2 ? '!' : ''

				}/${valueExist(countValues.value3) ? numberWithSpaces(countValues.value3) : '-'

				}${countValues.showExclamation3 ? '!' : ''

				}`}</p>

			<p>{`(${valueExist(volumeValues.value1) ? renderLitresToHL(volumeValues.value1, 2) : '-'

				}${volumeValues.showExclamation1 ? '!' : ''

				}/${valueExist(volumeValues.value2) ? renderLitresToHL(volumeValues.value2, 2) : '-'

				}${volumeValues.showExclamation2 ? '!' : ''

				}/${valueExist(volumeValues.value3) ? renderLitresToHL(volumeValues.value3, 2) : '-'

				}${volumeValues.showExclamation3 ? '!' : ''
				
				} hl)`}</p>

		</div>
	)
}